module.exports = __webpack_public_path__ + "img/bg-movie.242e954c.jpg";